import { createSelector } from "@reduxjs/toolkit";

import type { RootState } from "types/redux";

export const getNotificationBadgeCount = (state: RootState) => state.domains.notifications.badgeCount;

export const getNotification = (id: string) => (state: RootState) => state.domains.notifications.data[id];

export const createNotificationsSelector = (ids: string[]) =>
  createSelector(...ids.map(getNotification), (...notifications) => notifications);

export const getNotificationHasNextPage = (state: RootState) => state.domains.notifications.hasNextPage;

export const getNotificationIsPending = (state: RootState) => state.domains.notifications.isPending;

export const getNotificationList = (state: RootState) => state.domains.notifications.list;

export const getNotificationListOffset = (state: RootState) => state.domains.notifications.offset;
